import {
  apiStatus,
  bicActionType,
  merchantActionType,
} from '../../../actionTypes';

const initialState = {
  apiState: apiStatus.NONE,
  errorMessage: '',
  page: 1,
  categoryIds: [],
  brandIds: [],
  allMerchants: [],
  featuredMerchants: [],
};

const merchants = (state = initialState, action) => {
  switch (action.type) {
    case merchantActionType.INIT_MERCHANT_SCREEN_REQUEST:
      return {
        ...state,
        errorMessage: '',
        apiState: apiStatus.INITIATED,
      };
    case merchantActionType.INIT_MERCHANT_SCREEN_SUCCESS:
      const {
        allMerchants,
        featuredMerchants,
        categoryIds,
        brandIds,
        isCategoryPage,
      } = action.payload || {};
      return {
        ...state,
        errorMessage: '',
        apiState: isCategoryPage ? apiStatus.NONE : apiStatus.SUCCESS,
        allMerchants,
        featuredMerchants,
        categoryIds: categoryIds || [],
        brandIds: brandIds || [],
      };
    case merchantActionType.INIT_MERCHANT_SCREEN_ERROR:
      const { errorMessage } = action.payload || {};
      return {
        ...state,
        errorMessage,
        apiState: apiStatus.ERROR,
      };
    case merchantActionType.LOAD_MORE_MERCHANT:
      const { page } = action.payload || {};
      return {
        ...state,
        page: page > 0 ? page : 1,
      };

    case bicActionType.CLICK_CATEGORY: {
      const { categoryIds } = action.payload || {};
      return {
        ...state,
        categoryIds: categoryIds || [],
      };
    }
    case bicActionType.CLICK_BRAND: {
      const { brandIds } = action.payload || {};
      return {
        ...state,
        brandIds: brandIds || [],
      };
    }
    case merchantActionType.CLEAR_SEARCH_TEXT: {
      const { categoryIds, brandIds } = state || {};
      if (brandIds.length > 0 || categoryIds.length > 0) {
        return {
          ...initialState,
        };
      }
      return state;
    }
    case merchantActionType.CLEAR: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};

export default merchants;



// WEBPACK FOOTER //
// ./reducer/buyWithInstacred/merchants/index.js